import { OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_AUTH_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: `${window.location.origin}${process.env.REACT_APP_BASE_URL}/login/callback`,
  scopes: ['openid', 'email', 'profile', 'ges'],
  pkce: true,
  responseType: 'code',
  storageManager: {
    token: { storageType: 'cookie' },
  }
});

/**
 * OktaSecurityAuth Component
 */
const OktaSecurityAuth = (props) => {

  const navigate = useNavigate();
  // 2025.3.5 MyMine Version2.1対応 Modify Start
  const restoreOriginalUri = useCallback((_oktaAuth, originalUri) => {
    navigate('MyM703', { state: originalUri });
  }, [navigate])
  // 2025.3.5 MyMine Version2.1対応 Modify End

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {props.children}
    </Security>
  );
}
export default OktaSecurityAuth;

